import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 1. 导入 Vant 核心和样式
import Vant from 'vant'
import 'vant/lib/index.css'
import { initPageAdapt } from './utils/adapt.js'

// 只在开发环境启用 vconsole
// if (process.env.NODE_ENV !== 'production') {
  const VConsole = require('vconsole')
  new VConsole()
// }

const app = createApp(App).use(router).use(Vant)

// 全局路由跳转方法，供 Android 调用
// Android 可以通过 window.navigateToPage('/walkman/index') 来跳转
window.navigateToPage = (path) => {
  if (path) {
    router.push(path).catch(err => {
      console.error('路由跳转失败:', err)
    })
  }
}

// 全局 callJS 函数，处理 Android 原生调用
// 统一处理 getToken 和 getPageUrl，供所有页面使用
window.callJS = (data) => {
  try {
    const res = typeof data === 'string' ? JSON.parse(data) : data
    const { func, params } = res
    
    // 处理路由跳转
    if (func === 'navigate' && params && params.path) {
      router.push(params.path).catch(err => {
        console.error('路由跳转失败:', err)
      })
      return
    }
    
    // 统一处理 getToken（所有页面共享）
    if (func === 'getToken') {
      if (params) {
        // 保存 token
        if (params.accessToken) {
          localStorage.setItem('token', params.accessToken)
        }
        
        // 获取 host（可能是 host、baseUrl、domain 等字段）
        let host = params.host || params.baseUrl || params.domain || params.hostname || ''
        
        // 如果获取不到 host，使用固定的默认值
        if (!host) {
          host = 'ceplatform2.fenzhidao.com'
          console.log('⚠️ 未从安卓获取到 host，使用默认值:', host)
        }
        
        // 处理 host（确保格式正确）
        const dynamicHost = host
        // 如果 host 不包含协议，根据当前页面协议添加
        const protocol = host.startsWith('http') ? '' : (window.location.protocol === 'https:' ? 'https://' : 'http://')
        const dynamicBaseUrl = `${protocol}${host}/fzd-ceplatform-englishapp`
        const dynamicRagBaseUrl = `${protocol}${host}/fzd-ceplatform-rag`
        
        // 保存到 localStorage，供 request.js 使用
        localStorage.setItem('dynamicBaseUrl', dynamicBaseUrl)
        localStorage.setItem('dynamicRagBaseUrl', dynamicRagBaseUrl)
        localStorage.setItem('dynamicHost', dynamicHost)
        // 兼容旧代码
        localStorage.setItem('host', host)
        
        console.log('✅ [全局] 设置 host:', host)
        console.log('✅ [全局] 设置动态 baseUrl:', dynamicBaseUrl)
        console.log('✅ [全局] 设置动态 ragBaseUrl:', dynamicRagBaseUrl)
      } else {
        // 如果 params 为空，使用固定的默认值
        const defaultHost = 'ceplatform2.fenzhidao.com'
        const protocol = window.location.protocol === 'https:' ? 'https://' : 'http://'
        const dynamicHost = defaultHost
        const dynamicBaseUrl = `${protocol}${defaultHost}/fzd-ceplatform-englishapp`
        const dynamicRagBaseUrl = `${protocol}${defaultHost}/fzd-ceplatform-rag`
        
        localStorage.setItem('dynamicBaseUrl', dynamicBaseUrl)
        localStorage.setItem('dynamicRagBaseUrl', dynamicRagBaseUrl)
        localStorage.setItem('dynamicHost', dynamicHost)
        localStorage.setItem('host', defaultHost)
        
        console.log('⚠️ [全局] params 为空，使用默认值:', defaultHost)
        console.log('✅ [全局] 设置动态 baseUrl:', dynamicBaseUrl)
        console.log('✅ [全局] 设置动态 ragBaseUrl:', dynamicRagBaseUrl)
      }
      return
    }
    
    // 统一处理 getPageUrl（所有页面共享）
    if (func === 'getPageUrl') {
      if (params && params.pageUrl) {
        router.push(params.pageUrl).catch(err => {
          console.error('路由跳转失败:', err)
        })
      }
      return
    }
  } catch (error) {
    console.error('callJS 解析失败:', error)
  }
}

// 全局函数：请求 token（供所有页面调用）
window.getToken = () => {
  const tokenRequest = JSON.stringify({
    func: 'getToken',
  })
  if (window.android) {
    window.android.callNative(tokenRequest)
  }
}

// 全局函数：请求 pageUrl（供所有页面调用）
window.getPageUrl = () => {
  const getPageUrlRequest = JSON.stringify({
    func: 'getPageUrl',
  })
  if (window.android) {
    window.android.callNative(getPageUrlRequest)
  }
}

// 应用启动时检查 URL hash，如果有路由就跳转
// Android 可以通过加载 file:///android_asset/music/walkman/index.html#/chat/index 来直接跳转
router.isReady().then(() => {
  const hash = window.location.hash
  if (hash && hash !== '#/') {
    // hash 模式会自动处理，这里只是确保路由已就绪
    console.log('当前路由:', hash)
  }
})

// 挂载 app
app.mount('#app')

// 在 app 挂载后初始化适配，确保 #app 元素已存在
// 使用 nextTick 确保 DOM 已更新
setTimeout(() => {
  initPageAdapt()
}, 0)
